/**
 * @generated SignedSource<<39c42c43cafe24091b8af7034499ddf9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSocialShareEmail_item$data = {
  readonly firstPhotoWebPath: string | null;
  readonly serviceId: string | null;
  readonly skus: ReadonlyArray<{
    readonly firstPhotoWebPath: string | null;
    readonly serviceId: string | null;
  } | null> | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSendToFriendModalLazy_item">;
  readonly " $fragmentType": "PdpSharedSocialShareEmail_item";
};
export type PdpSharedSocialShareEmail_item$key = {
  readonly " $data"?: PdpSharedSocialShareEmail_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSocialShareEmail_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "small"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"small\")"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSocialShareEmail_item",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSendToFriendModalLazy_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "6c012a191dc1a7e9dc9549056bbdb8af";

export default node;
